import { render, staticRenderFns } from "./LotDetailsForm.vue?vue&type=template&id=2b38d820&"
import script from "./LotDetailsForm.vue?vue&type=script&lang=js&"
export * from "./LotDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports